import imageWhy from '../../Images/Home/imageWhy.svg';
import '../../Styles/Sass/WhyConnect.scss';

function App() {
  return (
    <section className='whyConnect'>
    	<h3 className='whyConnect__title'>Why You Should Use Clean Connection</h3>
    	<ul className='whyConnect__list'>
    		<li className='whyCard'>
    			<img className='whyCard__image' src={imageWhy} alt="" />
    			<h3 className='whyCard__title'>Trusted Service</h3>
    			<p className='whyCard__description'>Description Description Description Description</p>
    		</li>
    		<li className='whyCard'>
    			<img className='whyCard__image' src={imageWhy} alt="" />
    			<h3 className='whyCard__title'>Easy to Use</h3>
    			<p className='whyCard__description'>Description Description Description Description</p>
    		</li>
    		<li className='whyCard'>
    			<img className='whyCard__image' src={imageWhy} alt="" />
    			<h3 className='whyCard__title'>Scout an Expert</h3>
    			<p className='whyCard__description'>Description Description Description Description</p>
    		</li>
    		<li className='whyCard'>
    			<img className='whyCard__image' src={imageWhy} alt="" />
    			<h3 className='whyCard__title'>Total Transparency</h3>
    			<p className='whyCard__description'>Description Description Description Description</p>
    		</li>
    	</ul>
    </section>
  );
}

export default App;
